import { render, staticRenderFns } from "./PFormSelectMulti.vue?vue&type=template&id=7f56a589&scoped=true&"
import script from "./PFormSelectMulti.vue?vue&type=script&lang=ts&"
export * from "./PFormSelectMulti.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelectMulti.vue?vue&type=style&index=0&id=7f56a589&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56a589",
  null
  
)

export default component.exports